import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import FormGroup from './FormGroup';
import flags from '../constants/flags';
import { rem, colors } from '../lib/global-styles';
import { getCurrentCardBrand } from '../store/selectors';
import helpImage from '../images/ic_help.svg';
import { doShowModal } from '../store/actions';
import Modal from './Modal/Modal';
import { cvvHelp } from '../constants/content';
import { validateCardForm } from '../lib/utils';

const Form = styled.div`
  text-indent: 0;
  margin-top: ${rem(20)};
`;

const CvvHelp = styled.img`
  display: inline-block;
  cursor: pointer;
  position: absolute;
  top: ${rem(34)};
  right: ${rem(30)};
`;

const FormGroupLine = styled.div`
  display: flex;

  div:first-child {
    padding-right: 0;
    margin-right: ${rem(15)};
  }
`;

const ErrorMessage = styled.div`
  color: ${colors.red};
  font-size: ${rem(12)};
  line-height: ${rem(16)};
  margin-top: ${rem(5)};
  font-weight: normal;
  text-align: left;
`;

class CardForm extends Component {
  state = {
    blurError: {
      number: '',
      validity: '',
      cvv: '',
    },
  };

  componentDidMount() {
    const { error } = this.props;
    this.setState({ error });
  }

  onClickCvvHelp = e => {
    e.preventDefault();
    this.props.onShowModal(e.target.dataset.target);
  };

  onBlurInput = e => {
    const { card } = this.props;
    const { validated, error } = validateCardForm(card, e.target.name);

    if (!validated) {
      this.setState({ blurError: error });
    }
  };

  render() {
    const { card, onChangeInput, currentCardBrand, children, filled, error, width } = this.props;
    const { blurError } = this.state;

    return (
      <>
        <Form filled={filled} width={width}>
          <FormGroup
            id="card-number"
            name="number"
            type="tel"
            mask={currentCardBrand === flags.Amex ? '9999 999999 99999' : '9999 9999 9999 9999'}
            label="Número do cartão de crédito"
            placeholder="0000 0000 0000 0000"
            onChangeValue={onChangeInput}
            value={card.number}
            autoComplete="off"
            onBlurValue={this.onBlurInput}
          >
            <ErrorMessage>{error.number || blurError.number}</ErrorMessage>
          </FormGroup>

          <FormGroupLine>
            <FormGroup
              id="card-date"
              name="validity"
              type="tel"
              mask="99/99"
              value={card.validity}
              label="Validade"
              placeholder="Mês/Ano"
              onChangeValue={onChangeInput}
              onBlurValue={this.onBlurInput}
            >
              <ErrorMessage>{error.validity || blurError.validity}</ErrorMessage>
            </FormGroup>

            <FormGroup
              id="card-cvv"
              name="cvv"
              type="tel"
              mask="9999"
              value={card.cvv}
              label="Cód.segurança"
              placeholder="CVV/CVC"
              onChangeValue={onChangeInput}
              onBlurValue={this.onBlurInput}
            >
              <CvvHelp
                src={helpImage}
                alt="CVV"
                className="cvv-help"
                onClick={this.onClickCvvHelp}
                data-target="cvv-help"
              />
              <ErrorMessage>{error.cvv || blurError.cvv}</ErrorMessage>
            </FormGroup>
          </FormGroupLine>
          {children}
        </Form>
        <Modal target="cvv-help" targetClass="cvv-help-modal" content={cvvHelp} />
      </>
    );
  }
}

CardForm.propTypes = {
  currentCardBrand: PropTypes.string,
  card: PropTypes.object.isRequired,
  error: PropTypes.object.isRequired,
  onChangeInput: PropTypes.func.isRequired,
  filled: PropTypes.bool,
  onShowModal: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  currentCardBrand: getCurrentCardBrand(state),
});

const mapDispatchToProps = dispatch => ({
  onShowModal: target => dispatch(doShowModal(target)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CardForm);
